module.exports = __webpack_public_path__ + "static/media/ic-activity-active.ff2723d4.svg";